// 🦠 B247 (AI_111) — Campo de entrada de sorologia (Fase 2). Renderiza o controle
// certo conforme o TIPO do campo (fonte: normalizarSorologia):
//  • qualitativa / anti-HBs → lista Reagente / Não Reagente / Indeterminado
//  • carga viral → número OU rótulo (Não detectado / Detectável não quantificável)
//  • genótipo e demais → texto livre
// O valor RECEBIDO é normalizado só para EXIBIR (assim um valor antigo "Positivo"
// já aparece como "Reagente"). O onChange devolve o valor padronizado escolhido.
import React from "react";
import { theme } from "../../../shared/styles/theme";
import {
  TIPO_SOROLOGIA,
  OPCOES_QUALITATIVA,
  ROTULO_CARGA_NAO_DETECTADO,
  ROTULO_CARGA_NAO_QUANTIFICAVEL,
  normalizarSorologia,
  normalizarCargaViral,
} from "../services/normalizarSorologia";

const controle: React.CSSProperties = {
  width: "100%",
  padding: "10px 12px",
  border: `1px solid ${theme.gray[300]}`,
  borderRadius: theme.borderRadius.md,
  fontSize: "14px",
  fontFamily: theme.fonts.sans,
  boxSizing: "border-box",
  background: "white",
};

interface Props {
  campo: string;
  valor: string;
  onChange: (v: string) => void;
  desabilitado?: boolean;
}

export default function CampoSorologia({ campo, valor, onChange, desabilitado }: Props) {
  const tipo = TIPO_SOROLOGIA[campo];

  // Qualitativa e anti-HBs → lista padronizada.
  if (tipo === "qualitativa" || tipo === "antiHBs") {
    const atual = normalizarSorologia(campo, valor) ?? "";
    return (
      <select
        style={controle}
        value={atual}
        disabled={desabilitado}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">—</option>
        {OPCOES_QUALITATIVA.map((o) => (
          <option key={o} value={o}>
            {o}
          </option>
        ))}
      </select>
    );
  }

  // Carga viral → número OU rótulo (nunca 0).
  if (tipo === "cargaViral") {
    const norm = normalizarCargaViral(valor);
    const ehRotulo =
      norm === ROTULO_CARGA_NAO_DETECTADO || norm === ROTULO_CARGA_NAO_QUANTIFICAVEL;
    const modo = ehRotulo ? (norm as string) : "numero";
    const numero = typeof norm === "number" ? String(norm) : "";
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
        <select
          style={controle}
          value={modo}
          disabled={desabilitado}
          onChange={(e) => {
            const m = e.target.value;
            onChange(m === "numero" ? "" : m);
          }}
        >
          <option value="numero">Valor numérico…</option>
          <option value={ROTULO_CARGA_NAO_DETECTADO}>{ROTULO_CARGA_NAO_DETECTADO}</option>
          <option value={ROTULO_CARGA_NAO_QUANTIFICAVEL}>
            {ROTULO_CARGA_NAO_QUANTIFICAVEL}
          </option>
        </select>
        {modo === "numero" && (
          <input
            type="number"
            style={controle}
            value={numero}
            disabled={desabilitado}
            placeholder="UI/mL ou cópias/mL"
            onChange={(e) => onChange(e.target.value)}
          />
        )}
      </div>
    );
  }

  // Genótipo e demais → texto livre.
  return (
    <input
      type="text"
      style={controle}
      value={valor || ""}
      disabled={desabilitado}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}
